export default
{
  USER_CREATED: 'USER_CREATED',
  TRIP_CREATED: 'TRIP_CREATED',
  TRIP_COMPLETED: 'TRIP_COMPLETED',
};
